<div>

  <p-table [value]="applicationsInfo">
    <ng-template pTemplate="header">
      <tr>
        <th>Artifact ID</th>
        <th>Version No.</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-info>
      <tr>
        <td>{{ info.artifactId }}</td>
        <td>{{ info.version }}</td>
      </tr>
    </ng-template>
  </p-table>
  
  <div class="infoVersion" (click)="createJSON()">    
  </div>
  
  <div class="" *ngIf="show.versionInfo">
      <pre>{{jsonObj | json}}</pre>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/administration/infopage/infopage.component.html